import TextField from "@material-ui/core/TextField/TextField";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useSearchContainersImportQuery } from "../../../services/bl-import/BLImportService";

interface props {
  error?: boolean;
  helperText?: React.ReactNode;
  onChange: (value?: string) => void;
}

const AutocompleteSearchContainer = ({
  error,
  helperText,
  onChange,
}: props) => {
  const [search, setSearch] = useState("");

  const { data /* isLoading */ } = useSearchContainersImportQuery(
    {
      search,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const options = data?.map((row) => row.contenedores) || [];

  return (
    <>
      <Autocomplete
        options={options}
        onChange={(_, value) => {
          onChange(value || "");
        }}
        renderInput={(props) => (
          <TextField
            {...props}
            variant="outlined"
            fullWidth
            error={error}
            helperText={helperText}
            onChange={(val) => setSearch(val.currentTarget.value)}
            onFocus={() => setSearch("")}
            placeholder="Buscar Contenedor"
          />
        )}
      />
    </>
  );
};

export default AutocompleteSearchContainer;
